import { INSURANCE_SUB_PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
var logger = getLogger('MarketplaceApplyNow');
export default (function (_ref) {
  var text = _ref.text,
    useUpdatedInsuranceCTAs = _ref.useUpdatedInsuranceCTAs;
  if (useUpdatedInsuranceCTAs) {
    return {
      vertical: 'Insurance',
      text: text !== null && text !== void 0 ? text : 'Get a Quote'
    };
  }
  return {
    vertical: 'Insurance',
    text: text !== null && text !== void 0 ? text : 'Apply Now'
  };
});
export var determineFlowLink = function determineFlowLink(subProductType) {
  if (subProductType === INSURANCE_SUB_PRODUCT_TYPES.AUTO || subProductType === INSURANCE_SUB_PRODUCT_TYPES.CAR || subProductType === INSURANCE_SUB_PRODUCT_TYPES.CLASSIC_CAR) {
    return "".concat(appConfig === null || appConfig === void 0 ? void 0 : appConfig.SITE_BASE_URL, "/insurance/match");
  }
  if (subProductType === INSURANCE_SUB_PRODUCT_TYPES.HOME || subProductType === INSURANCE_SUB_PRODUCT_TYPES.HOMEOWNERS_PROPERTY || subProductType === INSURANCE_SUB_PRODUCT_TYPES.RENTERS || subProductType === INSURANCE_SUB_PRODUCT_TYPES.RENTERS_SUB) {
    return "".concat(appConfig === null || appConfig === void 0 ? void 0 : appConfig.SITE_BASE_URL, "/home-insurance/match");
  }
  if (subProductType === INSURANCE_SUB_PRODUCT_TYPES.LIFE || subProductType === INSURANCE_SUB_PRODUCT_TYPES.LIFE_SUB || subProductType === INSURANCE_SUB_PRODUCT_TYPES.UNIVERSAL_LIFE || subProductType === INSURANCE_SUB_PRODUCT_TYPES.VARIABLE_LIFE) {
    return "".concat(appConfig === null || appConfig === void 0 ? void 0 : appConfig.SITE_BASE_URL, "/insurance/life/match");
  }
  if (subProductType === INSURANCE_SUB_PRODUCT_TYPES.TRAVEL) {
    return "".concat(appConfig === null || appConfig === void 0 ? void 0 : appConfig.SITE_BASE_URL, "/insurance/travel/match");
  }
  logger.error('No SubProductType found for Insurance Offer - falling back to review link');
  return null;
};